/* ============================================================================
   dom.js — one-shot DOM resolver.

   game.js never queries the document directly; it reads elements from the
   DOM namespace that this module fills in at boot.  If any required id is
   missing from the markup, we surface the problem immediately rather than
   crashing later at a `null.textContent = …` call.

   Adding a new element id?  Add it to the MAP below AND to the section liquid.
   ========================================================================= */
(function(){
'use strict';

// camelCase alias (used in code) -> id attribute in the markup
const MAP = {
  // stage / overlays
  stage:        'stage',
  cam:          'cam',
  game:         'game',

  // HUD
  hud:          'hud',
  timerbar:     'timerbar',
  timerfill:    'timerfill',
  clock:        'clock',
  score:        'score',
  live:         'live',

  // overlays
  count:        'count',
  toast:        'toast',

  // start screen
  start:        'start',
  startCookie:  'start-cookie',
  startBtn:     'startBtn',

  // results screen
  over:         'over',
  hero:         'hero',
  heroName:     'hero-name',
  heroSub:      'hero-sub',
  statTotal:    'stat-total',
  statScore:    'stat-score',
  breakdown:    'breakdown',
  selfieBtn:    'selfieBtn',
  againBtn:     'againBtn',

  // selfie screen
  selfie:       'selfie',
  selfcanvas:   'selfcanvas',
  captureBtn:   'captureBtn',
  backBtn:      'backBtn',

  // unsupported screen (no camera / no motion sensor)
  unsupported:    'unsupported',
  unsupportedMsg: 'unsupported-msg',
  retryBtn:       'retryBtn',
};

const DOM = window.DOM = {};

DOM.init = function(){
  const missing = [];
  for(const alias in MAP){
    const id = MAP[alias];
    const el = document.getElementById(id);
    if(!el) missing.push(id);
    DOM[alias] = el;
  }
  if(missing.length){
    const msg = 'Cookie Catcher: required DOM ids missing — ' + missing.join(', ');
    console.error(msg);
    document.body.style.cssText =
      'background:#fff;color:#FA0A11;font:14px monospace;padding:24px;margin:0';
    document.body.innerHTML =
      '<h2 style="margin:0 0 8px">Markup is out of sync with cookie-hunt-dom.js</h2>' +
      '<p>The following element ids are referenced by the engine but not present in the section:</p>' +
      '<ul>' + missing.map(id => '<li><code>#' + id + '</code></li>').join('') + '</ul>';
    throw new Error(msg);
  }
};

// Scripts load deferred so the DOM is fully parsed; resolve ids immediately.
DOM.init();
})();
